import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { StepContainer, StepLabel } from "~/OnboardingApp/components";
import { Trans } from "~/utils/i18next";

export const WhatYouNeedStep: FC = () => {
  const { t } = useTranslation();

  return (
    <StepContainer>
      <Flex w="full">
        <Text textAlign="center">
          <Trans i18nKey="onboarding.welcomePage.step1.content" />
        </Text>
        <StepLabel>{t("onboarding.welcomePage.step1.estimatedTime")}</StepLabel>
      </Flex>
    </StepContainer>
  );
};
